import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {UserService} from "../../../services/user.service";
import {AppDataService} from "../../../services/app-data.service";
import {InstagramUserBean} from "../../../beansts/instagram.user.bean";
import {EventBean} from "../../../beansts/Event";
import {CompanyBean} from "../../../beansts/company.bean";
import { TranslationService } from '../../../services/translation.service';

import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import {WalletService} from "../../../services/wallet.services";

declare let $: any;
declare var Swal : any;

@Component({
    selector : 'transaction-history-modal',
    templateUrl:'transaction-history-component.html',

})
export class TransactionHistoryModalComponent implements OnInit, OnDestroy{

  public processing : boolean=false;
  public transactions=[]

  private user : InstagramUserBean;
  public constructor( private _router : Router,public _walletService: WalletService, public translate: TranslationService,private _auth : UserService,public _appData : AppDataService,private fb : FormBuilder, private _companyService : CompanyService) {
    }

    public ngOnInit(): any {

      this._walletService.getTransactions(this._appData.instagramUser.uid,'user').subscribe(val=>{
        this.transactions=val.json();
      });

    }

    public onChange (params){
      this.ngOnInit();
  };
public buyLivecoins(){
  $('#profileModal').modal('hide')
  $('#cardModal').modal('show')


}
public tradeForLivecoins(transaction){
  this._walletService.transactionToLivecoin(transaction,'user').subscribe(val=>{
    Swal.fire(this.translate.instant('SUCCESS'),"Sua transação virou livecoins")
    this.transactions=[]
    this._walletService.getTransactions(this._appData.instagramUser.uid,'user').subscribe(val=>{
      this.transactions=val.json();
    });

  })
}
    public ngOnDestroy() : any {
    }






  
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+easylogin/transactionHistory/transaction-history-component.ts